<template>
  <NuxtLayout>
    <div class="error-container">
      <h1 class="error-title">404</h1>
      <p class="error-message">페이지를 찾을 수 없습니다</p>
      <NuxtLink to="/" class="is-16b home-link">홈으로 돌아가기</NuxtLink>
    </div>
  </NuxtLayout>
</template>

<script setup>
const error = useError()
</script>

<style scoped lang="scss">
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 50vh;
  text-align: center;
  background-color: #f8f9fa;
}

.error-title {
  font-size: 6rem;
  font-weight: bold;
  color: #dc3545;
  margin-bottom: 1rem;
}

.error-message {
  font-size: 1.5rem;
  color: #6c757d;
  margin-bottom: 2rem;
}

.home-link {
  padding: 0.75rem 1.5rem;
  background-color: #007bff;
  color: white;
  text-decoration: none;
  border-radius: 5px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #0056b3;
  }
}
</style>
